var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-distributions-by-contact-property",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm._l(_vm.data, function (property) {
        return _c(
          "div",
          { key: property.propertyId, staticClass: "property-chart" },
          [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("h3", [_vm._v(_vm._s(property.propertyLabel))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "IconButton",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: _vm.$t("chart.chartView") },
                              expression: "{ content: $t('chart.chartView') }",
                            },
                          ],
                          attrs: {
                            classNames: _vm.tableModes[property.propertyId]
                              ? ""
                              : "selected",
                            onClick: function () {
                              return _vm.setTableMode(
                                property.propertyId,
                                false
                              )
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("insights")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "IconButton",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: _vm.$t("chart.tableView") },
                              expression: "{ content: $t('chart.tableView') }",
                            },
                          ],
                          attrs: {
                            classNames: _vm.tableModes[property.propertyId]
                              ? "selected"
                              : "",
                            onClick: function () {
                              return _vm.setTableMode(property.propertyId, true)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("table_view")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "IconButton",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: _vm.$t("chart.download") },
                              expression: "{ content: $t('chart.download') }",
                            },
                          ],
                          attrs: {
                            onClick: function () {
                              return _vm.exportToExcel(property)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("download")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "IconButton",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: _vm.$t("chart.fullScreen") },
                              expression: "{ content: $t('chart.fullScreen') }",
                            },
                          ],
                          attrs: { onClick: _vm.switchToFullScreenMode },
                        },
                        [
                          !_vm.fullScreen
                            ? _c("md-icon", [_vm._v("fullscreen")])
                            : _c("md-icon", [_vm._v("fullscreen_exit")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-radio-group",
                    {
                      attrs: { "button-style": "solid" },
                      model: {
                        value: _vm.chartTypes[property.propertyId],
                        callback: function ($$v) {
                          _vm.$set(_vm.chartTypes, property.propertyId, $$v)
                        },
                        expression: "chartTypes[property.propertyId]",
                      },
                    },
                    [
                      _c("a-radio-button", { attrs: { value: "bar" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.columnChart"))),
                      ]),
                      _vm._v(" "),
                      _c("a-radio-button", { attrs: { value: "pie" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.pieChart"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-wrapper" },
              [
                !_vm.tableModes[property.propertyId] &&
                _vm.chartTypes[property.propertyId] === "bar"
                  ? _c("EChartsHorizontalBar", {
                      attrs: {
                        labels: _vm.getLabels(property),
                        datasets: _vm.getBarDatasets(property),
                        height: _vm.getChartHeight(property),
                      },
                    })
                  : !_vm.tableModes[property.propertyId] &&
                    _vm.chartTypes[property.propertyId] === "pie"
                  ? _c(
                      "div",
                      { staticClass: "pie-chart-wrapper" },
                      [
                        _c("EChartsDoughnut", {
                          attrs: {
                            labels: _vm.getLabels(property),
                            datasets: _vm.getPieDatasets(property),
                            height: 400,
                          },
                        }),
                      ],
                      1
                    )
                  : _c("TableView", {
                      attrs: {
                        cols: _vm.getCols(),
                        rows: _vm.getRows(property),
                      },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stats" },
              [
                _c("StatCard", {
                  attrs: {
                    title: _vm.$t("chart.mostUsed"),
                    value: _vm.getStats(property).maxValue,
                  },
                }),
                _vm._v(" "),
                _c("StatCard", {
                  attrs: {
                    title: _vm.$t("chart.leastUsed"),
                    value: _vm.getStats(property).minValue,
                  },
                }),
                _vm._v(" "),
                _c("StatCard", {
                  attrs: {
                    title: _vm.$t("chart.totalPersonCount"),
                    value: _vm.formatStat(_vm.getStats(property).total).value,
                    unit: _vm.$t("chart.personsUnit"),
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-divider"),
          ],
          1
        )
      }),
      _vm._v(" "),
      !_vm.loading && (!_vm.data || _vm.data.length === 0)
        ? _c("a-empty")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }